/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const camelToTitleCase = (camelCaseString) => {
  // handle null string
  if (camelCaseString == null) {
    return "";
  }

  // split the camel case string into an array of words
  const words = camelCaseString.split(/(?=[A-Z])/);

  // capitalize the first letter of each word and join them into a string
  const titleCaseString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

  return titleCaseString;
}
